import { createSelector } from 'reselect';

export const getIntl = state => state.intl;
export const getLocale = createSelector(getIntl, state => state.locale);
export const getEditLanguage = () => 'de'; // TODO Add handling multiple edit languages and a switch
export const getMessages = createSelector(getIntl, state => state.messages.messages);
export const getUrlPrefix = createSelector(getIntl, state => state.urlPrefix);
export const getDisplayIntlForm = createSelector(getIntl, state => state.displayIntlForm);
export const getAllowedLanguages = createSelector(getIntl, state => state.allowedLanguages);

export default {
  getIntl,
  getLocale,
  getEditLanguage,
  getMessages,
  getUrlPrefix,
  getDisplayIntlForm,
  getAllowedLanguages,
};
